import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { SosService } from '../../core/services/sos.service';

@Component({
  selector: 'app-sso-callback',
  templateUrl: './sso-callback.component.html',
  styleUrls: ['./sso-callback.component.scss']
})
export class SsoCallbackComponent implements OnInit {
  loading = true;
  error: string | null = null;

  constructor(
    private sosService: SosService,
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      params['revoke'] === 'logout' ? this.authService.logout() : null;
    });
    this.router.navigate(['/login'], {
      queryParams: { audience: 'freeZones' }
    });
  }

}